import React from 'react';
import { i18next } from '@yola/ws-sdk';
import { designSystem } from '@yola/ws-ui';
import { ROOT_ID } from '../constants/index.js';

const { Paragraph } = designSystem;

// eslint-disable-next-line yola/react/prop-types
const DeletePageTitleComponent = ({ children }) => (
  <Paragraph appearance="danger">{children}</Paragraph>
);

const buildActions = (item, context) => {
  const {
    isHome,
    isActive,
    isDeveloperConsoleEnabled,
    aiGeneratePageCopyEnabled,
    onSetHomePageClick,
    onCopyPageClick,
    onPageSettingsClick,
    onTranslatePageClick,
    onGeneratePageCopyClick,
    onDeveloperConsoleClick,
    onDeletePageClick,
  } = context;

  const isDeveloperConsoleAvailable = isDeveloperConsoleEnabled && isActive;

  const actions = [];

  if (!isHome) {
    actions.push({
      id: 'setHomePage',
      iconGlyph: 'home',
      divider: 'after',
      title: i18next.t('Set Home Page'),
      onClick: (e) => onSetHomePageClick(e, item),
    });
  }

  actions.push({
    id: 'copyPage',
    iconGlyph: 'copy',
    title: `${i18next.t('Duplicate')}...`,
    onClick: (e) => onCopyPageClick(e, item.id),
  });

  actions.push({
    id: 'pageSettings',
    iconGlyph: 'settings',
    title: `${i18next.t('Settings')}...`,
    onClick: (e) => onPageSettingsClick(e, item),
  });

  actions.push({
    id: 'translatePage',
    iconGlyph: 'translate',
    title: `${i18next.t('Translate to')}...`,
    onClick: (e) => onTranslatePageClick(e, item.id),
  });

  if (aiGeneratePageCopyEnabled) {
    actions.push({
      id: 'generatePageCopy',
      iconGlyph: 'ai',
      title: `${i18next.t('Generate page copy')}...`,
      onClick: () => onGeneratePageCopyClick(item.id),
    });
  }

  if (isDeveloperConsoleAvailable) {
    actions.push({
      id: 'developerConsole',
      iconGlyph: 'html',
      divider: 'before',
      title: `${i18next.t('Developer console')}...`,
      onClick: (e) => onDeveloperConsoleClick(e, item),
    });
  }

  if (!isHome) {
    actions.push({
      id: 'deletePage',
      iconGlyph: 'trash',
      iconType: 'error',
      divider: 'before',
      component: DeletePageTitleComponent,
      title: i18next.t('Delete'),
      onClick: (e) => onDeletePageClick(e, item),
    });
  }

  return actions;
};

const buildPageTreeItems = (items, context) => {
  const itemsWithMeta = items.map((item) => ({
    item,
    isHome: context.isHomePage(item),
    isActive: item.id === context.activePageId,
  }));
  const sortedItems = [...itemsWithMeta].sort((a, b) => {
    if (a.isHome) return -1;
    if (b.isHome) return 1;
    const aName = (a.item.name || '').toLowerCase();
    const bName = (b.item.name || '').toLowerCase();
    return aName.localeCompare(bName);
  });

  return sortedItems.map(({ item, isHome, isActive }) => ({
    id: item.id,
    parent: ROOT_ID,
    text: item.title || item.name,
    droppable: false,
    draggable: false,
    // collapsed: false, Only set collapsed if item is a folder
    data: {
      ...item,
      isActive,
      iconGlyph: isHome ? 'home' : 'page',
      actions: buildActions(item, { ...context, isHome, isActive }),
    },
  }));
};

export default buildPageTreeItems;
